var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterGreyPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1514 -561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0a8,8,0,1,0,8,8A7.993,7.993,0,0,0,8,0Z",
    transform: "translate(1514 561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,6.013,6.013,7,3.5,4.487.987,7,0,6.013,2.513,3.5,0,.987.987,0,3.5,2.513,6.013,0,7,.987,4.487,3.5Z",
    transform: "translate(1522 564.05) rotate(45)",
    fill: "#3b3b3b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterGreyPlus);
export default __webpack_public_path__ + "static/media/filter_grey-plus.248dcf8bbf16f0ee14cc3700d7405dc8.svg";
export { ForwardRef as ReactComponent };